import React from 'react';
import styles from '../styles/Loader.module.css';

const Loader = () => {
  return (
    <div className={styles.loaderContainer}>
      <div className={styles.loaderContent}>
        <span className={styles.typingText}>
          stockkhata | invest anywhere maintain only here
        </span>
      </div>
    </div>
  );
};

export default Loader; 